export const PANAMA_BANKS = [
  "Banco General",
  "Banistmo",
  "BAC Credomatic",
  "Banco Nacional de Panamá",
  "Caja de Ahorros",
  "Global Bank",
  "Multibank",
  "Scotiabank",
  "Banesco",
  "Credicorp Bank",
  "Banco Aliado",
  "BiBank",
  "Banco Lafise",
  "Mercantil Banco",
  "Towerbank",
  "Banco Delta",
  "Banco Pichincha",
  "Davivienda",
  "St. Georges Bank",
  "Metrobank",
  "Unibank",
  "Capital Bank",
  "Banco Prival",
  "Banco La Hipotecaria",
  "Canal Bank",
  "Citibank",
  "MMG Bank",
  "Banco Ficohsa",
  "Banco Azteca",
];

export const OTHER_BANK = "__other__";
